import { model as router } from '!/router'
import { combine, type Store } from 'effector'
import { model as paymentModel } from '~/features/payment/generic'
import type { TvChannelPayment } from '~/features/payment/interfaces'
import { genPlayerPaymentLogic } from '~/widgets/Payment/PlayerPaymentButton'
import { formatEpgTvChannelPayment } from './helpers'
import { $epgActiveChannel } from './index'

const $epgTvChannelPayment: Store<TvChannelPayment | null> = combine(
  $epgActiveChannel,
  router.$query,
  (channel, query) => {
    if (!channel) return null

    return formatEpgTvChannelPayment(channel, query)
  }
)

export const { openPlayerPaymentPopup, $paymentButtonText, $showPaymentPopup } =
  genPlayerPaymentLogic({
    entityStore: $epgTvChannelPayment,
    paymentEvent: paymentModel.selectTvChannelOnEpg,
  })
